import { render, staticRenderFns } from "./send-candidate-ask.vue?vue&type=template&id=28f231ed&scoped=true"
import script from "./send-candidate-ask.vue?vue&type=script&lang=ts"
export * from "./send-candidate-ask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f231ed",
  null
  
)

export default component.exports